<template>
  <div :class="$style.container">
    <vs-tooltip text="Доступно только ответственному" :active="!canChangeManager">
      <app-button
        v-if="isChangePerformerAvailable"
        @click="onChangeManager"
        :class="$style.button"
        color="warning"
        :disabled="!canChangeManager"
      >
        Назначить исполнителя
        <app-icon :class="$style.icon" name="RightArrowIcon" size="14px" />
      </app-button>
    </vs-tooltip>

    <vs-tooltip text="Доступно только исполнителю" :active="!canTakeToWork">
      <app-button
        v-if="isTakeToWorkAvailable"
        @click="onTakeToWork"
        :class="$style.button"
        color="warning"
        :disabled="!canTakeToWork"
      >
        Взять в работу
        <app-icon :class="$style.icon" name="RightArrowIcon" size="14px" />
      </app-button>
    </vs-tooltip>

    <vs-tooltip text="Доступно только исполнителю" :active="!canComplete">
      <app-button
        v-if="isCompleteAvailable"
        @click="onComplete"
        :class="$style.button"
        color="success"
        :disabled="!canComplete"
      >
        Завершить
        <app-icon :class="$style.icon" name="CheckIcon" size="14px" />
      </app-button>
    </vs-tooltip>

    <div v-if="isCancelled" :class="$style.message">Заявка отклонена.</div>

    <div v-if="isCompleted" :class="$style.message">Заявка выполнена.</div>
  </div>
</template>

<script>
import {
  ISSUE_STATUS_ASSIGNED,
  ISSUE_STATUS_CANCELLED, ISSUE_STATUS_COMPLETE,
  ISSUE_STATUS_NEW,
  ISSUE_STATUS_UNASSIGNED, ISSUE_STATUS_WORK,
}                from "@/constants/issues";
import parseJSON from "@/utils/parseJSON";

export default {
  name:     "IssueAction",
  props:    ['issue', 'onUpdate'],
  computed: {
    currentUserId() {
      return this.$store.getters['appUser/id'];
    },

    isCurrentUserAdmin() {
      const { issue } = this;
      return this.$can('issues.admin', 'access', issue.buildings_id);
    },

    canChangeManager() {
      const { issue, currentUserId } = this;
      return issue.manager_id === currentUserId || this.isCurrentUserAdmin;
    },

    canTakeToWork() {
      const { issue, currentUserId } = this;
      return issue.performer_id === currentUserId || this.isCurrentUserAdmin;
    },

    canComplete() {
      const { issue, currentUserId } = this;
      return issue.performer_id === currentUserId || this.isCurrentUserAdmin;
    },

    isChangePerformerAvailable() {
      const { issue } = this;
      return (
        issue.status_id === ISSUE_STATUS_NEW ||
        issue.status_id === ISSUE_STATUS_UNASSIGNED
      );
    },

    isTakeToWorkAvailable() {
      const { issue } = this;
      return issue.status_id === ISSUE_STATUS_ASSIGNED;
    },

    isCompleteAvailable() {
      const { issue } = this;
      return issue.status_id === ISSUE_STATUS_WORK;
    },

    isCancelled() {
      return this.issue.status_id === ISSUE_STATUS_CANCELLED;
    },

    isCompleted() {
      return this.issue.status_id === ISSUE_STATUS_COMPLETE;
    },
  },
  methods:  {
    onChangeManager() {
      this.$modal.open({
        size:           'md',
        title:          'Назначить исполнителя',
        component:      () => import('@/components/common/issues/IssueChangeManagerModal'),
        componentProps: {
          issue:           this.issue,
          onChangeManager: ( performer_id ) => {
            return this.onUpdate({ status_id: ISSUE_STATUS_ASSIGNED, performer_id });
          },
        },
      });
    },

    onTakeToWork() {
      return this.onUpdate({ status_id: ISSUE_STATUS_WORK });
    },

    onComplete() {
      this.$modal.open({
        size:           'xs',
        title:          'Завершить заявку',
        component:      () => import('@/components/common/issues/IssueCompleteModal'),
        componentProps: {
          onComplete: ( message ) => {
            const additional = parseJSON(this.issue.additional) || {};
            additional.doneActions = message;
            return this.onUpdate({ status_id: ISSUE_STATUS_COMPLETE, additional: JSON.stringify(additional) });
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" module>
.container {
  width: 300px;
  padding-right: 30px;
}

.button {
  width: 100%;
  height: 100%;
  display: block;
  border: 0;
  text-align: left;
  position: relative;
}

.icon {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
}

.message {
  font-size: 1.4rem;
  font-style: italic;
}
</style>
